import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import CommonJson from '@Src/Common.json'
import RoutesJson from '@LayOut/Routes/Routes.json'

const appendMsg = (json, content, lang,notKeys) => {
    
    for (const key of Object.keys(content)) {
        if (content[key][lang]) {
            json[key] = content[key][lang];
        } else {
            if (!notKeys || notKeys.indexOf(key) === -1) {
                if(typeof content[key] === 'object'){
                    json[key] = {};
                    appendMsg(json[key], content[key],lang,notKeys);
                }
            }
        }
    }
    
}
const getResourcesFromFile = (lang) => {
    const outJson = { "comMsg": {},"routes": {}};

    const app = require.context('@App', true, /\.json$/);

    for(const filePath of app.keys()){
        let [, folderName, fileName] = filePath.split('/');
    
        fileName = fileName.replace('.json', '');
        
        if (!outJson[folderName]) {
            outJson[folderName] = {};
        }
        
        if (!outJson[folderName][fileName]) {
            outJson[folderName][fileName] = {};
        }

        const content = app(filePath);

        appendMsg(outJson[folderName][fileName], content, lang);
    }
    
    appendMsg(outJson["comMsg"], CommonJson, lang);

    appendMsg(outJson["routes"], RoutesJson, lang,['url']);
    
    return outJson;
}


const lang =  localStorage.getItem("lang") ? localStorage.getItem("lang") : 'ko';
i18n.use(initReactI18next).init({
    resources : {
        ko : {translation: getResourcesFromFile("ko")},
        en : {translation: getResourcesFromFile("en")}
    },
    lng: lang,
    fallbackLng: ["ko","en"],
    debug: false,
    keySeparator: '/',
    interpolation: {escapeValue: false},
    react: {useSuspense: false}
}) 

export default i18n;